// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1k0z6","col":"styles_col__3LXwT"};